<template>
  <fragment>
    <Label
      v-bind="labelProps"
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
    >
      {{ label }}
    </Label>
    <DatePicker
      :lang="lang"
      v-model="input"
      :format="format"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="inputClass"
      :clearable="false"
      :range="range"
      :confirm="range"
      @change="change"
      confirm-text="Buscar"
    />
    <div
      class="input-description input-margin"
      v-if="description"
      :class="descriptionClass"
    >
      {{ description }}
    </div>
  </fragment>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import Label from './Label';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

export default {
  name: 'InputDate',
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {},
    label: {
      type: String,
    },
    type: {
      type: String,
      default: () => 'date',
    },
    confirm: {
      type: Boolean,
      default: () => false,
    },
    confirmText: {
      type: String,
      default: () => 'Buscar',
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    range: {
      type: Boolean,
      default: () => true,
    },
    format: {
      type: String,
      default: () => 'DD/MM/YYYY',
    },
    labelProps: {
      type: Object,
    },
    placeholder: {
      type: String,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    DatePicker,
    Label,
  },
  data() {
    return {
      input: null,
      lang: {
        formatLocale: {
          monthsShort: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro',
          ],
          weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
          monthBeforeYear: false,
        },
      },
    };
  },
  mounted() {
    if (this.value) {
      this.input =
        this.input instanceof Date ? this.value : new Date(moment(this.value));
    }

    this.setCalendarType();
  },
  methods: {
    change(value) {
      this.$emit('input', value);
    },
    setCalendarType() {
      if (!this.range) return;

      this.setIntervalOfDays();
    },
    setIntervalOfDays() {
      const date = new Date();
      const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDayOfMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
      );
      this.input = [firstDayOfMonth, lastDayOfMonth];
    },
  },
  computed: {
    inputClass() {
      return {
        'input-calendar': true,
        'input-margin': !this.description,
        success: this.success,
        error:
          this.error ||
          (this.required && (Array.isArray(this.data) || !this.data)),
      };
    },
    descriptionClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
  },
  watch: {
    value(old, _) {
      if (Array.isArray(old)) {
        this.input = old;
        return;
      }

      this.input = new Date(moment(old));
    },
  },
};
</script>
